module.exports = __webpack_public_path__ + "img/34.c39ed6d8.jpg";